import { PropertyCard } from '@/components/property/PropertyCard';

interface Props {
  project: any;
  layout?: 'list' | 'grid';
}

/**
 * Project banner card used inside the search-result feed.
 * Renders exactly like a PropertyCard (same dimensions, same internals)
 * with `cardType="project"` and `highlight` toggled on so it gets a
 * primary-tinted border + "New Project" ribbon — the only visual
 * differences from a regular property card.
 */
export function ProjectFeedBanner({ project, layout = 'grid' }: Props) {
  // Flatten developer / agency contact fields so PropertyCard's existing
  // project handling (price_min/_max, contact_phone, agency_name) works.
  const dev = project.developer_profiles;
  const agency = project.agencies;
  const mapped = {
    ...project,
    contact_phone: project.contact_phone || dev?.phone || agency?.phone,
    contact_person: project.contact_person || dev?.company_name || agency?.name,
    agency_name: agency?.name,
    developer_name: dev?.company_name,
    agency_logo_url: agency?.logo_url || dev?.logo_url,
  };

  return <PropertyCard property={mapped} layout={layout} cardType="project" highlight />;
}
